import {
    aos,
    swiper,
    ajax_post_filter,
    searchFocus,
    filterItemFunc,
    filter_count,
    selectedFiltersUI,
    mobileFiltersBtn,
    fullScreenSlider,
    scrollAnimation,
    campaignsSlider,
    accordion,
    bannersSlider,
} from './components/index';


const Tbc = {
    init() {
        aos();
        swiper();
        ajax_post_filter();
        searchFocus();
        filterItemFunc();
        filter_count();
        selectedFiltersUI();
        mobileFiltersBtn();
        fullScreenSlider();
        scrollAnimation();
        campaignsSlider();
        accordion();
        bannersSlider();
    }
};

export default Tbc;

Tbc.init();

document.addEventListener("DOMContentLoaded", function() {
    AOS.init({
        duration: 800,
    });
});
